import { useState } from 'react'

import type { ILabelProps, IOption } from 'components/uiKit/KitTypes'
import type { ISelectLabelProps } from 'components/uiKit/Select'

export const MIX = Symbol('MIX')
export type MixedValue = typeof MIX
export const isMixed = (value: unknown, defaultValue?: unknown): value is MixedValue =>
  value === MIX || (value === undefined && defaultValue === MIX)

interface IOptionLabelProps<V> extends ILabelProps, ISelectLabelProps {
  option?: IOption<V>
}

export const flatOptions = <V extends { options?: V[] }>(options: V[] = []): V[] =>
  options.reduce<V[]>((acc, cur) => {
    if (cur.options?.length) {
      acc.push(...flatOptions(cur.options))
    } else {
      acc.push(cur)
    }

    return acc
  }, [])

export const OptionLabel = <V,>({ option, ...rest }: IOptionLabelProps<V>) => {
  if (typeof option?.label === 'function') {
    const Label = option.label
    return <Label {...option} {...rest} />
  }
  return option?.label ?? option?.value
}

export const useHover = () => {
  const [hover, setHover] = useState(false)

  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)

  return [hover, { onMouseEnter, onMouseLeave }] as const
}
